module.exports = __webpack_public_path__ + "img/swimming.c900736.png";